import { useEffect, useState } from 'react';
export const useTrack = (publication) => {
    var _a;
    const [track, setTrack] = useState((_a = publication === null || publication === void 0 ? void 0 : publication.track) !== null && _a !== void 0 ? _a : null);
    useEffect(() => {
        var _a;
        // Reset the track when the 'publication' variable changes.
        setTrack((_a = publication === null || publication === void 0 ? void 0 : publication.track) !== null && _a !== void 0 ? _a : null);
        if (!publication)
            return;
        const removeTrack = () => {
            setTrack(null);
        };
        publication.on('subscribed', setTrack);
        publication.on('unsubscribed', removeTrack);
        return () => {
            publication.off('subscribed', setTrack);
            publication.off('unsubscribed', removeTrack);
        };
    }, [publication]);
    return track;
};
//# sourceMappingURL=useTrack.js.map